import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Space } from "antd";
import { ReactComponent as PlusIcon } from "../../assets/icons/WhitePlus.svg";
import { SortType } from "../../interfaces/screens/fetch-params-types";

import {
  StyledFilterButton,
  StyledFiltersBar,
  StyledSearchBar,
  StyledSortIcon,
} from "../common/styles";
import { StyledDropdown } from "../../screens/trainers/components/header/style";

export const TableHeader = (props: {
  search: string;
  setSearch: (value: string) => void;
  setSort: (value: SortType) => void;
  handleCreateNew: () => void;
  createNewText: string;
  currentSortBy: string;
}) => {
  const { t } = useTranslation();
  const {
    search,
    setSearch,
    setSort,
    handleCreateNew,
    createNewText,
    currentSortBy,
  } = props;

  const handleSort = (e: any) => {
    setSort({ sortBy: e.key, sortOrder: e.key === "updatedAt" ? -1 : 1 });
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const sortByOptions = [
    {
      key: "name",
      label: t("Sort by A-Z"),
    },
    {
      key: "updatedAt",
      label: t("Sort by Last Update"),
    },
  ];

  return (
    <StyledFiltersBar>
      <Button
        type="primary"
        shape="round"
        icon={<PlusIcon width={8} height={8} />}
        iconPosition="end"
        onClick={handleCreateNew}
      >
        {t(createNewText)}
      </Button>
      <StyledSearchBar
        placeholder={t("Search") + "..."}
        value={search}
        onChange={handleSearchChange}
        allowClear
      />
      <StyledDropdown
        menu={{
          items: sortByOptions,
          onClick: handleSort,
          selectedKeys: [currentSortBy],
        }}
        trigger={["click"]}
        placement="bottomRight"
        overlayStyle={{ width: 150, direction: "rtl" }}
      >
        <Space>
          <StyledFilterButton type="text" icon={<StyledSortIcon />}>
            {t("Sort")}
          </StyledFilterButton>
        </Space>
      </StyledDropdown>
    </StyledFiltersBar>
  );
};
